import journalHelper from "@/helper/journalHelper";
import enums from "../../enums/enums";
import userInfo from "../../function/userInfo";
import {
  GetAllocationListWithOutZeroPercent,
  GetAllocationTransactionEquals,
  default as transactionItemHelper,
} from "../../helper/transactionItemHelper.js";
import {
  GetCreateAllocationJournal,
  GetCreateAllocationJournalItem,
} from "../../service/transaction/transactionHelper";

export default {
  GetCreateJournalInput(status, journal) {
    let journalInput = {
      description: journal.description.text,
      journalType: journal.type.value,
      status: status,
      journalNumber: journal.number.text,
      journalDate: journal.date.value,
      contactId: journal.contact.value,
      referenceName: journal.reference.text,
      journalItemList: [],
      allocationTransactionList: GetCreateAllocationJournal(journal.allocationTransactionList),
      fileList: journal.fileList,
      tagList: journal.tagList,
    };
    if (journal.journalItemList) {
      for (let journalItem of journal.journalItemList) {
        let newJournalItem = {
          accountId: journalItem.account.id,
          description: journalItem.description.text,
          debit: journalItem.debit.value,
          credit: journalItem.credit.value,
          accountRefId: 0,
          accountRefIdRefType: 0,
          allocationTransactionList: journalItem.isUseTransactionAllocation
            ? GetCreateAllocationJournal(journal.allocationTransactionList)
            : GetCreateAllocationJournalItem(journalItem.allocationTransactionList),
        };

        if (journalItem.subAccount && journalItem.subAccount.code) {
          newJournalItem.accountRefIdRefType = journalItem.subAccount.referenceTypeId;
          newJournalItem.accountRefId = journalItem.subAccount.referenceId;
        }

        journalInput.journalItemList.push(newJournalItem);
      }
    }
    return {
      merchantId: userInfo.MerchantId(),
      journal: journalInput,
    };
  },
  GetUpdateJournalInput(journal) {
    let journalInput = {
      id: journal.id,
      description: journal.description.text,
      journalType: journal.type.value,
      status: journal.status,
      journalNumber: journal.number.text,
      journalDate: journal.date.value,
      contactId: journal.contact.value,
      referenceName: journal.reference.text,
      journalItemList: [],
      allocationTransactionList: GetCreateAllocationJournal(journal.allocationTransactionList),
      fileList: journal.fileList,
      tagList: journal.tagList,
    };
    if (journal.journalItemList) {
      for (let journalItem of journal.journalItemList) {
        let newJournalItem = {
          id: journalItem.id,
          accountId: journalItem.account.id,
          description: journalItem.description.text,
          debit: journalItem.debit.value.ToNumber(),
          accountRefId: 0,
          accountRefIdRefType: 0,
          credit: journalItem.credit.value.ToNumber(),
          stockActivityId: journalItem.stockActivityId,
          isReconciled: journalItem.isReconciled,
          paymentRefId: journalItem.paymentReferenceId,
          reconciledGroupId: journalItem.reconciledGroupId,
          allocationTransactionList: journalItem.isUseTransactionAllocation
            ? GetCreateAllocationJournal(journal.allocationTransactionList)
            : GetCreateAllocationJournalItem(journalItem.allocationTransactionList),
        };

        if (journalItem.subAccount && journalItem.subAccount.code) {
          newJournalItem.accountRefIdRefType = journalItem.subAccount.referenceTypeId;
          newJournalItem.accountRefId = journalItem.subAccount.referenceId;
        }
        journalInput.journalItemList.push(newJournalItem);
      }
    }

    if (journal.allocationList && journal.allocationList.length > 0) {
      journal.allocationList.forEach((allocation) => {
        journalInput.allocationTransactionList.push({
          allocationId: allocation.allocationId,
          allocationItemList: allocation.allocationItemList,
        });
      });
    }
    return journalInput;
  },
  ConvertToJournalDetail(journal, isCopy = false, isReverse = false, allocationList = []) {
    let journalDetail = {
      id: journal.id,
      date: {
        value: new Date(journal.journalDate),
      },
      number: {
        text: journal.journalNumber,
      },
      journalItemList: [],
      type: {
        value: isReverse ? enums.JournalType.GeneralJournal : journal.journalType,
        name: "",
      },
      reference: {
        text: journal.referenceName,
        referenceId: journal.referenceId,
        referenceTypeId: journal.journalRefType,
      },
      description: {
        text: isReverse
          ? journalHelper.GetReversedJournalDescription(journal.description, journal.journalNumber)
          : journal.description,
      },
      contact: {
        value: journal.contactId,
        name: "",
      },
      debit: {
        value: 0,
      },
      credit: {
        value: 0,
      },
      lock: {
        statusId: journal.lockStatusId ? journal.lockStatusId : enums.LockStatus.Unlock,
        date: new Date(journal.lockDateTime).GetDateFormat(),
        userId: journal.lockUserId,
      },
      isReconciled: journal.isReconciled,
      isDeleted: journal.isDeleted,
      validationStatus: journal.validationStatus,
      status: journal.status,
      allocationList: GetAllocationListWithOutZeroPercent(journal.allocationTransactionList),
      allocationTransactionList: transactionItemHelper.SetEditAllocationJournal(
        journal.allocationTransactionList,
        allocationList
      ),
      createdUserId: journal.createdUserId,
      approvedUserId: journal.approvedUserId,
      reviewedUserId: journal.reviewedUserId,
      subReferenceId: journal.subReferenceId,
      subReferenceType: journal.subReferenceType,
    };

    if (journal.journalItemList) {
      for (let journalItem of journal.journalItemList) {
        let journalItemDetail = {
          id: journalItem.id,
          account: {
            id: journalItem.accountId,
            code: "",
            name: "",
            nameEng: "",
            nameTH: "",
            referenceTypeId: 0,
          },
          subAccount: {
            code: "",
            name: "",
            referenceId: journalItem.accountRefId,
            referenceTypeId: journalItem.accountRefIdRefType,
          },
          description: {
            text: isReverse
              ? journalHelper.GetReversedJournalDescription(journalItem.description, journal.journalNumber)
              : journalItem.description,
          },
          debit: {
            value: isReverse ? journalItem.credit : journalItem.debit,
          },
          credit: {
            value: isReverse ? journalItem.debit : journalItem.credit,
          },
          paymentReferenceId: !isCopy ? journalItem.paymentRefId : 0,
          isAdjustPayment: !isCopy ? journalItem.isAdjustPayment : false,
          isReconciled: !isCopy ? journalItem.isReconciled : false,
          reconciledGroupId: !isCopy ? journalItem.reconciledGroupId : 0,
          stockActivityId: journalItem.stockActivityId,
          isUseTransactionAllocation: true,
          isAccountReferenceFixAsset:
            journalItem.accountRefIdRefType == enums.JournalAccountReferenceType.FixAssetTemplate,
          allocationList: GetAllocationListWithOutZeroPercent(journalItem.allocationTransactionList),
          allocationTransactionList: transactionItemHelper.SetEditAllocationJournal(
            journalItem.allocationTransactionList,
            allocationList
          ),
        };
        if (journalItemDetail.allocationList && journalItemDetail.allocationList.length > 0) {
          let allocationTransactionEquals = GetAllocationTransactionEquals(
            journalDetail.allocationList,
            journalItemDetail.allocationList
          );
          journalItemDetail.isUseTransactionAllocation = allocationTransactionEquals;
        }

        journalDetail.debit.value += journalItem.debit.ToNumber();
        journalDetail.credit.value += journalItem.credit.ToNumber();
        let debit = journalDetail.debit.value;
        let credit = journalDetail.credit.value;
        journalItem.isDebit = debit - credit > 0;
        if (journalItem.isDebit) {
          journalItem.itemNetAmountTotal = debit.FormatMoney();
        } else {
          journalItem.itemNetAmountTotal = credit.FormatMoney();
        }
        journalDetail.journalItemList.push(journalItemDetail);
      }
    }
    return journalDetail;
  },
  ConvertToReferencedJournal(_referencedJournalList) {
    let referencedJournalList = [];
    if (_referencedJournalList && _referencedJournalList.length > 0) {
      _referencedJournalList.forEach((referencedJournal) => {
        referencedJournalList.push({
          journalId: referencedJournal.journalId,
          journalNumber: referencedJournal.journalNumber,
          journalRefId: referencedJournal.journalRefId,
          journalRefTypeId: referencedJournal.journalRefTypeId,
          journalRefName: referencedJournal.journalRefName,
          isDeleted: referencedJournal.isDeleted,
          journalLockStatus: referencedJournal.journalLockStatus,
          journalUuid: referencedJournal.journalUuid,
        });
      });
    }

    return referencedJournalList;
  },
  ConvertToTagJournal(_tag) {
    let tag = [];
    if (_tag.length > 0) {
      _tag.forEach((item) => {
        tag.push({
          tagId: item.tagId,
          tagName: item.tagName,
          tagJournalId: item.tagJournalId,
        });
      });
    }
    return tag;
  },
  ConvertToReceivedTaxInvoice(_receivedTaxInvoice) {
    // let receivedTaxInvoice = [];
    // if (_receivedTaxInvoice.length > 0) {
    //   _receivedTaxInvoice.forEach((item) => {
    //     receivedTaxInvoice.push({
    //       receivedTaxInvoiceNumber: item.receivedTaxInvoiceNumber,
    //       receivedTaxInvoiceDate: new Date(item.receivedTaxInvoiceDate).GetDateFormat(),
    //     });
    //   });
    // }
    let receivedTaxInvoice = {
      receivedTaxInvoiceNumber: _receivedTaxInvoice.receivedTaxInvoiceNumber
        ? _receivedTaxInvoice.receivedTaxInvoiceNumber
        : "",
      receivedTaxInvoiceDate: _receivedTaxInvoice.receivedTaxInvoiceDate
        ? new Date(_receivedTaxInvoice.receivedTaxInvoiceDate).GetDateFormat()
        : "",
    };
    return receivedTaxInvoice;
  },
  GetJournalViewDetailList(journalViewDetailRawList) {
    const journalViewDetailList = [];
    if (journalViewDetailRawList && journalViewDetailRawList.length > 0) {
      for (const journalViewDetailRaw of journalViewDetailRawList) {
        journalViewDetailList.push({
          id: journalViewDetailRaw.id,
          number: journalViewDetailRaw.number,
          contactId: journalViewDetailRaw.contactId,
          date: journalViewDetailRaw.date,
        });
      }
    }
    return journalViewDetailList;
  },
};
